<script>
export default {
    emits: ['update:active'],

    /**
     * The component's local methods.
     *
     * @type {Object}
     */
    methods: {
        onChangeTab(tab) {
            return this.$emit('update:active', tab)
        },
    },

    /**
     * The component's inherited properties.
     *
     * @type {Object}
     */
    props: {
        active: {
            type: [Object, Number, String],
            default: null,
        },

        tabs: {
            type: Array,
            default() {
                return []
            },
        },
    },
}
</script>

<template>
    <v-tabs
        class="w-full"
        :model-value="active"
        @update:model-value="onChangeTab"
        data-test="tabs"
    >
        <v-tab v-for="tab in tabs" :key="tab.name" :value="tab.name">
            {{ tab.label }}
        </v-tab>
    </v-tabs>
</template>
